"use client";

import {ManageBookings} from "@/components/pages/bookings/manageBookings/manageBookings";
import {SOS} from "@/components/pages/bookings/sos/sos";
import {Transaction} from "@/components/pages/bookings/transactions/transaction";
import {TripRatingPage} from "@/components/pages/bookings/tripRating/tripRatingPage";
import type {ComponentType} from "react";

export type BookingFilterRequest = {
  from: number | null;
  to: number | null;
};

export type BookingTabProps = {
  hasDateFilterChanged: boolean;
  searchValue: string;
  filterRequest: BookingFilterRequest;
  vehicleFilter?: string | null;
  driverFilter?: string;
};

export type BookingTabId =
  | "manageBookings"
  | "tripRating"
  | "sos"
  | "transactions";

type BookingReportMenuItem = {
  id: BookingTabId;
  label: string;
  component: ComponentType<BookingTabProps>;
};

export const BookingReportMenu: BookingReportMenuItem[] = [
  {
    id: "manageBookings",
    label: "Manage Bookings",
    component: ManageBookings
  },
  {
    id: "tripRating",
    label: "Trip Rating",
    component: TripRatingPage
  },
  {
    id: "sos",
    label: "SOS",
    component: SOS
  },
  {
    id: "transactions",
    label: "Transaction",
    component: Transaction
  }
];
